/* eslint-disable */

require("@/utils/extensions");
var validators = require("@/utils/validators");
const errors = [];
const fields = [];

const rbValidator = {
  data: () => ({
    errors: errors,
    fields: fields,
    canProceed: false
  }),
  computed: {
    run() {
      return this.data;
    }
  },
  methods: {
    clear: function() {
      this.errors = [];
    },
    addToError: function(key, error) {
      this.removeFromError(key);
      this.errors.push({ key: key, error: error });
    },
    removeFromError: function(key) {
      var index = this.errors.itemIndex(key);
      if (index !== -1) {
        this.errors.splice(index, 1);
      }
    },
    addErrorClass: function(el) {
      el.classList.add("is-invalid");
    },
    removeErrorClass: function(el) {
      el.classList.remove("is-invalid");
    },
    radioCheckedValueTrue: function(radios) {
      if (radios == null || radios.length === 0) return false;
      for (var i = 0; i < radios.length; i++) {
        if (radios[i].type === "radio" && radios[i].checked && radios[i].value.toBool()) {
          return true;
        }
      }
      return false;
    },
    radioChecked: function(radios) {
      if (radios == null || radios.length === 0) return false;
      for (var i = 0; i < radios.length; i++) {
        if (radios[i].type === "radio" && radios[i].checked) {
          return true;
        }
      }
      return false;
    },
    initializeMultiple(key, item, validations) {
      var vm = this; //current vue instance;
      var res = key.split(",");
      var containerId = key.replace(/,/g, "_");
      //console.log("id ", containerId);
      var container = document.getElementById(containerId);

      var invalidCount = 0;
      for (let i = 0; i < res.length; i++) {
        var id = res[i];
        var input = document.getElementById(id);

        //var item = validations[key];
        if (input != null) {
          if (input.getAttribute("hasBlur") === null) {
            //if (typeof (input.blurEvent) === "undefined") {
            input.addEventListener("blur", function(evt) {
              //console.log("item ", item);
              vm.validateMultiple(key, item, validations);
            });

            if (input.type == "password" || input.type == "text" || input.type == "textarea") {
              input.addEventListener("input", function(evt) {
                vm.validateMultiple(key, item, validations);
              });
            } else {
              input.addEventListener("change", function(evt) {
                vm.validateMultiple(key, item, validations);
              });
            }
            input.setAttribute("hasBlur", "");
          }
          continue;
        }

        var radios = document.getElementsByName(id);
        if (radios !== null && radios.length > 0 && item.required) {
          for (var j = 0; j < radios.length; j++) {
            var radio = radios[j];
            if (radio.type === "radio") {
              if (radio.getAttribute("hasBlur") === null) {
                radio.addEventListener("blur", function(evt) {
                  vm.validateMultiple(key, item, validations);
                });
                radio.addEventListener("change", function(evt) {
                  vm.validateMultiple(key, item, validations);
                });
                radio.setAttribute("hasBlur", "");
              }
            }
          }
        }
      }
    },
    initializeInput(key, item, validations) {
      var vm = this; //current vue instance;
      var input = document.getElementById(key);

      if (input !== null && (input.type == "password" || input.type == "text" || input.type == "textarea" || input.type == "select" || input.type == "select-one")) {
        //console.log("input found: ", input.type);
        if (item.required) {
          input.setAttribute("required", "");
        }

        if (input.getAttribute("hasBlur") === null) {
          //if (typeof (input.blurEvent) === "undefined") {
          input.addEventListener("blur", function(evt) {
            vm.validateField(key, validations);
          });

          if (input.type == "password" || input.type == "text" || input.type == "textarea") {
            input.addEventListener("input", function(evt) {
              vm.validateField(key, validations);
            });
          } else {
            input.addEventListener("change", function(evt) {
              vm.validateField(key, validations);
            });
          }
          //input.blurEvent = true;
          input.setAttribute("hasBlur", "");
        }
        return true; // input found
      }
      return false;
    },
    initializeRadio(key, item, validations) {
      var vm = this; //current vue instance;
      var radios = document.getElementsByName(key);
      if (radios !== null && radios.length > 0) {
        if (item.required) {
          if (typeof item.dependent !== "undefined" && item.dependent !== "") {
            var dependentItem = this.validations[item.dependent];
            var checked = this.radioCheckedValueTrue(radios);

            if (dependentItem != null && checked) {
              dependentItem.required = checked;
            }
          }

          radios[0].setAttribute("required", "");
          for (var i = 0; i < radios.length; i++) {
            var radio = radios[i];
            if (radio.type === "radio") {
              if (radio.getAttribute("hasBlur") === null) {
                radio.addEventListener("blur", function(evt) {
                  vm.validateRadio(key, validations);
                });
                radio.addEventListener("change", function(evt) {
                  vm.validateRadio(key, validations);
                });
                radio.setAttribute("hasBlur", "");
              }
            }
          }
        }
        return true; // radio found
      }
      return false;
    },
    resetValidation: function() {
      var vm = this; //current vue instance;
      let keys = this.errors.map(item => item.key);

      keys.forEach(key => {
        var input = document.getElementById(key);
        vm.removeFromError(key);
        if (typeof input !== "undefined" && input !== null) {
          vm.removeErrorClass(input);
        }
      });
    },
    init: function(formId, validations) {
      this.clear();
      var vm = this; //current vue instance;

      Object.keys(validations).forEach(key => {
        //console.log("init: ", key, " validation");
        var item = validations[key];

        if (key.indexOf(",") !== -1) {
          this.initializeMultiple(key, item, validations);
          return;
        }
        //console.log("init: ", key, " validation");

        var input = this.initializeInput(key, item, validations);
        if (input) return;

        var radio = this.initializeRadio(key, item, validations);
        if (radio) return;
      });
    },
    invokeValidator(itemFunc, value, additionalParam) {
      
      if (typeof additionalParam === "undefined" || additionalParam == null || additionalParam.length == 0) 
        return itemFunc(value);

      var additionalInput = document.getElementById(additionalParam);
      
      if (additionalInput != null) {
        return itemFunc(value, additionalInput.value);
      }
    },
    validateField(key, validations) {
      var input = document.getElementById(key);

      var item = validations[key];
      if (typeof (item) !== 'undefined' && item.required) {
        if (input.value.length === 0) {
          this.addErrorClass(input);
          this.addToError(key, validators.errorMessages.required);
          return;
        }
        
        if (typeof (item.validator) === 'function' && !this.invokeValidator(item.validator, input.value, item.additionalParam)) {
          this.addErrorClass(input);
          this.addToError(key, item.error);
          return;
        }
      }
      this.removeFromError(key);
      this.removeErrorClass(input);
    },
    validateRadio(key, validations) {
      var radios = document.getElementsByName(key);
      var checked = this.radioChecked(radios);

      var container = document.getElementById(key + "_container");
      if (container !== null) {
        if (!checked) {
          this.addErrorClass(container);
          this.addToError(container.id, validators.errorMessages.required);
          return;
        }

        this.removeFromError(container.id);
        this.removeErrorClass(container);
      }
    },
    validateMultiple(key, item, validations) {
      //console.log(key, " index ", key.indexOf(","));
      var res = key.split(",");
      var containerId = key.replace(/[,.]/gi, "_");
      //console.log("id ", containerId);
      var container = document.getElementById(containerId + "_container");

      var invalidCount = 0;
      for (let i = 0; i < res.length; i++) {
        var id = res[i];
        var input = document.getElementById(id);

        //var item = validations[key];
        if (input != null) {
          //console.log("id ", id, "   ", input);
          if (input.value.length === 0 && item.required) {
            invalidCount++;
          }
          continue;
        }

        var radios = document.getElementsByName(id);
        if (radios !== null && radios.length > 0 && item.required) {
          var checked = this.radioCheckedValueTrue(radios);
          //console.log("id ", id, "   ", checked);
          if (!checked) {
            invalidCount++;
          }
        }

        //console.log(" ", res[i]);
      }

      var validCount = res.length - invalidCount;
      //console.log("validCount: ", validCount);

      if (typeof item !== "undefined" && item.required) {
        if (invalidCount === res.length) {
          this.addErrorClass(container);
          this.addToError(container.id, validators.errorMessages.required);
          return;
        }
        if (typeof item.validator === "function" && !item.validator(validCount)) {
          this.addErrorClass(container);
          this.addToError(container.id, item.error);
          return;
        }
      }

      //if (invalidCount === res.length - 1){
      this.removeFromError(container.id);
      this.removeErrorClass(container);
      //}
      //   for (var key in obj) {
      //     if (!obj.hasOwnProperty(key)) continue;
      //     console.log(key, obj[key]);
      //  }

      // var input = document.getElementById(key);

      // if (input !== null) {
      //   this.validateField(key, validations);
      //   return; // input found
      // }

      // var radios = document.getElementsByName(key);
      // if (radios !== null) {
      //   this.validateRadio(key, validations);
      //   return; // radio found
      // }
    },
    validate: function(formId, validations) {
      this.clear();
      Object.keys(validations).forEach((key, indx) => {
        var item = validations[key];

        if (key.indexOf(",") > -1) {
          this.validateMultiple(key, item, validations);
          return;
        }

        //console.log("validate: ", key, " validation");
        var input = document.getElementById(key);

        if (input !== null) {
          this.validateField(key, validations);
          return; // input found
        }

        var radios = document.getElementsByName(key);
        if (radios !== null) {
          this.validateRadio(key, validations);
          return; // radio found
        }
      });
    },
    propExists: function(obj, prop) {
      if (obj.hasOwnProperty(prop)) {
        return true;
      }
      return false;
    },
    addJointPolicyHolderValidators: function(validations, jointValidations) {
      Object.keys(jointValidations).forEach(key => {
        if (!this.propExists(validations, key)) {
          validations[key] = jointValidations[key];
        }
      });
    },
    removeJointPolicyHolderValidators: function(validations, jointValidations) {
      Object.keys(jointValidations).forEach(key => {
        if (this.propExists(validations, key)) {
          delete validations[key];
        }
      });
    }
  }
};

export default rbValidator;
